import {ChangeDetectionStrategy, Component, computed, input, output} from '@angular/core';
import {VisitContext} from "../../../visit-context";
import {AppContext} from "../../../../app-context";
import {HarbourDuesDeclarationTab} from "../../types";
import {HarbourDuesUtilsService} from "../../services/harbour-dues-utils.service";
import {HarbourDuesPermissionService} from "../../services/harbour-dues-permission.service";
import {HarbourDuesDeclaration} from "@portbase/bezoekschip-service-typescriptmodels";

@Component({
  selector: 'app-harbour-dues-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class HarbourDuesHeaderComponent {
  readonly declarationTabs = input<HarbourDuesDeclarationTab[]>([]);
  readonly declarationSelected = input(false);
  readonly selectedDeclaration = input<HarbourDuesDeclaration | null>(null);
  readonly saveAndSendDisabled = input(false);
  readonly hasCurrentVersionInvoice = input(false);

  readonly tabSelected = output<HarbourDuesDeclarationTab>();
  readonly saveDraft = output<void>();
  readonly saveAndSend = output<void>();
  readonly declarationAccepted = output<void>();
  readonly declarationRejected = output<void>();

  protected readonly context = VisitContext;
  protected readonly appContext = AppContext;
  protected readonly invoicePeriod = this.utilsService.invoicePeriod;

  readonly canEdit = computed(() => {
    const decl = this.selectedDeclaration();
    return decl ? this.permissionService.canEdit(decl) : false;
  });

  readonly canSaveUndeclaredDeclaration = computed(() => {
    const decl = this.selectedDeclaration();
    return decl ? this.permissionService.canSaveUndeclaredDeclaration(decl) : false;
  });

  constructor(
    private utilsService: HarbourDuesUtilsService,
    private permissionService: HarbourDuesPermissionService) {
  }

  onTabChange(index: number) {
    const tab = this.declarationTabs()[index];
    this.tabSelected.emit(tab);
  }

  onSaveDraft(event: Event) {
    event.preventDefault();
    this.saveDraft.emit();
  }

  onSaveAndSend() {
    this.saveAndSend.emit();
  }

  onAccept() {
    this.declarationAccepted.emit();
  }

  onReject() {
    this.declarationRejected.emit();
  }
}
